
export default {
  settings: {
    endpointsSectionTitle: 'Service endpoints (URI or full URL)',
    language: 'Language',
    appLocale: 'App locale',
    unit: 'Unit',
    areaUnit: 'Area unit',
    saveToLocalStorage: 'Save in my browser',
    routeInstructions: 'Routing instructions',
    alternativeIsochroneColors: 'Alternative isochrone colors',
    distanceMarkers: 'Distance markers',
    elevationProfile: 'Elevation profile',
    mapSettings: 'Map view and extra information',
    defaultMapSettingsRestored: 'Default map settings restored and saved',
    endpointsTitle: {
      directions: 'Directions',
      isochrones: 'Isochrones',
      geocodeSearch: 'Geocode search',
      autocomplete: 'Geocode autocomplete',
      pois: 'POIs',
      reverseGeocode: 'Geocode reverse'
    },
    apiKey: 'API key',
    customApiKey: 'Custom API key',
    apiBaseUrl: 'API base URL',
    invalidSettingsValue: 'Invalid settings value(s). Please check the fields or restore default values',
    restoreDefaults: 'Restore defaults',
    advanced: 'Advanced',
    mapSettingsSaved: 'Map settings saved',
    alwaysFitBounds: 'Always fit bounds when route changes',
    routeExtraInfo: 'Route extra info',
    mapViewOptions: 'Map view options',
    advancedSettingsWarning: 'Do not change the settings below if you do not know what you are doing!',
    customOverlayerTileProviderUrl: 'Custom overlayer provider URL',
    customTileProviderUrl: 'Custom tiles provider URL',
    defaultTilesProvider: 'Default tiles provider',
    customTileProviderUrlHint: 'https://domain.tld/path/{z}/{x}/{y}.ext?optionalKey=value',
    prioritizeSearchingForNearbyPlaces: 'Prioritize searching for nearby places',
    defaultProfile: 'Default profile',
    compressDataUrlSegment: 'Compress URL segment after /data/',
    autoFitHighlightedBounds: 'Auto fit highlighted bounds',
    reloadToApplyLanguageChangeTitle: 'It is necessary to reload the app',
    reloadToApplyLanguageChangeText: 'In order to fully apply the language change it is necessary to reload the app. Reload now?',
    resetShownOnceTooltips: 'Show tooltips on app load again',
    convertStopAfterRouteEndingToDestination: 'Convert stop added at the end of the route to final destination',
    skipAllSegments: 'straight route for all segments',
    useStopOptimization: 'Optimize the route when a stop is created via drag-and-drop'
  }
}
